import * as CS from "../../Common/styles";

export const AdditionalComments = (props) => {
    return (
        <CS.Section>
            <CS.H3>Additional Comments</CS.H3>
            <CS.TextArea id='additionalComments' placeholder='Additional comments (optional)' rows='4' onChange={props.onChange} value={props.additionalComments} />
        </CS.Section>
    );
}